// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fr-phone-cta[data-v-4caf0b28]{display:flex;flex-direction:row;justify-content:center;margin:.5rem}.mobile-display[data-v-4caf0b28]{display:none}@media(max-width:600px){.desktop-display[data-v-4caf0b28]{display:none}.mobile-display[data-v-4caf0b28]{display:inline}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
